import { render, staticRenderFns } from "./ReportTuple.vue?vue&type=template&id=46445144&scoped=true&"
import script from "./ReportTuple.vue?vue&type=script&lang=js&"
export * from "./ReportTuple.vue?vue&type=script&lang=js&"
import style0 from "./ReportTuple.vue?vue&type=style&index=0&id=46445144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46445144",
  null
  
)

export default component.exports